module.exports = __webpack_public_path__ + "static/img/HappeningsEventsAdvancedMusics_Douglass-College_March1963-program_2.8bd2b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/HappeningsEventsAdvancedMusics_Douglass-College_March1963-program_2.jpg
// module id = uXrr
// module chunks = 0